import { useContext, useMemo } from 'react';
import { CardsContext } from '../context/CardsContext';
import { SiteContentContext } from '../context/SiteContentContext';

const IMG_KEYS = [
  'heroImage','studyHeroImage','adventuresHeroImage','racesHeroImage',
  'infoHeroImage','fleetHeroImage','teamHeroImage','faqHeroImage',
  'packingHeroImage','iymcsHeroImage','pricingHeroImage','founderPhoto','faviconUrl',
];

const TEXT_LABELS = {
  // О школе
  schoolName:           'Название школы',
  schoolSubtitle:       'Подзаголовок (шапка)',
  heroTitle:            'Заголовок главной',
  heroSubtitle:         'Подзаголовок главной',
  aboutTitle:           'Заголовок «О школе»',
  aboutText:            'О школе (текст 1)',
  aboutText2:           'О школе (текст 2)',
  founderName:          'Имя основателя',
  founderTitle:         'Должность основателя',
  founderText:          'Биография основателя',
  // Контакты
  email:                'Email',
  phone:                'Телефон',
  telegram:             'Telegram',
  instagram:            'Instagram',
  address:              'Адрес',
  coordinates:          'Координаты школы',
  // Цены
  pricePopupText:       'Текст попапа цены',
  pricePopupLinkText:   'Текст ссылки в попапе',
  pricingTitle:         'Заголовок страницы цен',
  pricingSubtitle:      'Подзаголовок страницы цен',
  pricingIntro:         'Вводный текст о ценах',
  pricingIncluded:      'Что включено в цену',
  pricingExcluded:      'Что оплачивается отдельно',
  pricingFooter:        'Заключительный текст (цены)',
  // Фичи главной / Почему выбирают нас
  whyTitle:             'Заголовок «Почему выбирают нас»',
  mainFeaturesTitle:    'Заголовок блока фич главной',
  mainFeaturesText:     'Подзаголовок блока фич главной',
  // Путешествия
  adventuresCtaTitle:       'CTA заголовок (путешествия)',
  adventuresCtaText:        'CTA текст (путешествия)',
  adventuresFeaturesTitle:  'Заголовок фич путешествий',
  adventuresFeaturesText:   'Текст под фичами путешествий',
  // Обучение
  studyCtaTitle:        'CTA заголовок (обучение)',
  studyCtaText:         'CTA текст (обучение)',
  studyFeaturesTitle:   'Заголовок фич обучения',
  studyFeaturesText:    'Текст под фичами обучения',
  // Регаты
  racesCtaTitle:        'CTA заголовок (регаты)',
  racesCtaText:         'CTA текст (регаты)',
  racesFeaturesTitle:   'Заголовок фич регат',
  racesFeaturesText:    'Текст под фичами регат',
  // IYMCS
  iymcsTitle:           'Заголовок IYMCS',
  iymcsSubtitle:        'Подзаголовок IYMCS',
  iymcsUrl:             'Ссылка IYMCS',
  iymcsText1:           'Описание IYMCS (1)',
  iymcsText2:           'Описание IYMCS (2)',
  // Направления главной
  dirStudyTitle:        'Направление — Обучение (заголовок)',
  dirStudyDesc:         'Направление — Обучение (описание)',
  dirStudyBtn:          'Направление — Обучение (кнопка)',
  dirRacesTitle:        'Направление — Соревнования (заголовок)',
  dirRacesDesc:         'Направление — Соревнования (описание)',
  dirRacesBtn:          'Направление — Соревнования (кнопка)',
  dirAdventuresTitle:   'Направление — Путешествия (заголовок)',
  dirAdventuresDesc:    'Направление — Путешествия (описание)',
  dirAdventuresBtn:     'Направление — Путешествия (кнопка)',
  // Цены по направлениям
  pricingStudyIncluded:     'Цены: обучение — что включено',
  pricingStudyExcluded:     'Цены: обучение — доп. расходы',
  pricingAdventureIncluded: 'Цены: путешествия — что включено',
  pricingAdventureExcluded: 'Цены: путешествия — доп. расходы',
  pricingRaceIncluded:      'Цены: регаты — что включено',
  pricingRaceExcluded:      'Цены: регаты — доп. расходы',
  // Правовые тексты
  privacyText:          'Политика конфиденциальности',
  personalDataText:     'Обработка персональных данных',
  // Блок «Задать вопрос» (цены)
  pricingCtaTitle:      'Заголовок блока «Задать вопрос» (цены)',
  pricingCtaText:       'Текст блока «Задать вопрос» (цены)',
};

const IMG_LABELS = {
  heroImage:            'Обложка главной',
  studyHeroImage:       'Обложка Обучение',
  adventuresHeroImage:  'Обложка Путешествия',
  racesHeroImage:       'Обложка Регаты',
  infoHeroImage:        'Обложка О школе',
  fleetHeroImage:       'Обложка Флот',
  teamHeroImage:        'Обложка Команда',
  faqHeroImage:         'Обложка FAQ',
  packingHeroImage:     'Обложка Что взять',
  iymcsHeroImage:       'Обложка IYMCS',
  pricingHeroImage:     'Обложка О ценах',
  founderPhoto:         'Фото основателя',
  faviconUrl:           'Favicon',
};

const TYPE_LABELS = { adventures: 'Путешествия', study: 'Обучение', races: 'Регаты', main: 'Новости', reviews: 'Отзывы' };

function truncate(str, n = 60) {
  if (!str) return '—';
  const s = String(str).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  return s.length > n ? s.slice(0, n) + '…' : s;
}

function ImageThumb({ src, label }) {
  if (!src) return <span style={{ color: '#aaa' }}>нет</span>;
  return (
    <img src={src} alt={label} style={{ height: 40, maxWidth: 80, objectFit: 'cover', borderRadius: 4, border: '1px solid #e0e0e0', verticalAlign: 'middle' }} />
  );
}

function fmtDate(iso) {
  if (!iso) return '?';
  const [y, m, d] = iso.split('-');
  const months = ['янв','фев','мар','апр','май','июн','июл','авг','сен','окт','ноя','дек'];
  return `${Number(d)} ${months[Number(m)-1]} ${y}`;
}

function diffArrayItems(prodArr, draftArr, labelFn) {
  const details = [];
  const maxLen = Math.max(prodArr.length, draftArr.length);
  for (let i = 0; i < maxLen; i++) {
    const p = prodArr[i];
    const d = draftArr[i];
    if (!p && d) { details.push({ sub: `добавлен пункт ${i+1}: «${labelFn(d)}»`, sign: '+' }); continue; }
    if (p && !d) { details.push({ sub: `удалён пункт ${i+1}: «${labelFn(p)}»`, sign: '-' }); continue; }
    if (JSON.stringify(p) !== JSON.stringify(d)) {
      details.push({ sub: `пункт ${i+1}: «${labelFn(p)}» → «${labelFn(d)}»`, sign: '~' });
    }
  }
  return details;
}

function diffVacations(pVac = [], dVac = []) {
  const fmt = (v) => `${fmtDate(v.startIso)} — ${fmtDate(v.endIso)}`;
  const pSet = pVac.map(fmt);
  const dSet = dVac.map(fmt);
  const added = dSet.filter(v => !pSet.includes(v));
  const removed = pSet.filter(v => !dSet.includes(v));
  const parts = [...added.map(v => `+${v}`), ...removed.map(v => `−${v}`)];
  return parts.join(', ');
}

function diffInstructors(prodList, draftList) {
  const details = [];
  const pMap = Object.fromEntries(prodList.map(i => [i.id, i]));
  const dMap = Object.fromEntries(draftList.map(i => [i.id, i]));
  for (const inst of draftList) {
    if (!pMap[inst.id]) { details.push({ sub: `добавлен: «${inst.name||'Инструктор'}»`, sign: '+' }); continue; }
  }
  for (const inst of prodList) {
    if (!dMap[inst.id]) { details.push({ sub: `удалён: «${inst.name||'Инструктор'}»`, sign: '-' }); continue; }
  }
  for (const d of draftList) {
    const p = pMap[d.id];
    if (!p) continue;
    const label = d.name || p.name || 'Инструктор';
    const subs = [];
    if ((p.name||'') !== (d.name||'')) subs.push(`имя: «${p.name||'—'}» → «${d.name||'—'}»`);
    if ((p.title||'') !== (d.title||'')) subs.push(`должность: «${p.title||'—'}» → «${d.title||'—'}»`);
    if ((p.bio||'') !== (d.bio||'')) subs.push('биография изменена');
    if ((p.photo||'') !== (d.photo||'')) subs.push('фото изменено');
    if (JSON.stringify(p.vacations||[]) !== JSON.stringify(d.vacations||[])) {
      const v = diffVacations(p.vacations, d.vacations);
      subs.push('отпуска' + (v ? `: ${v}` : ' изменены'));
    }
    if (subs.length > 0) details.push({ sub: `«${truncate(label,40)}»: ${subs.join(', ')}`, sign: '~' });
  }
  return details;
}

function diffAdvantages(prodAdv, draftAdv) {
  const details = [];
  const maxLen = Math.max(prodAdv.length, draftAdv.length);
  for (let i = 0; i < maxLen; i++) {
    const p = prodAdv[i];
    const d = draftAdv[i];
    const label = d?.title || p?.title || `#${i+1}`;
    if (!p && d) { details.push({ sub: `добавлено: «${truncate(label, 40)}»`, sign: '+' }); continue; }
    if (p && !d) { details.push({ sub: `удалено: «${truncate(label, 40)}»`, sign: '-' }); continue; }
    const subs = [];
    if (p.icon !== d.icon) subs.push(`иконка: ${p.icon||'нет'} → ${d.icon||'нет'}`);
    if ((p.customIcon||'') !== (d.customIcon||'')) subs.push(`кастом SVG изменён`);
    if ((p.title||'') !== (d.title||'')) subs.push(`заголовок: «${truncate(p.title,30)}» → «${truncate(d.title,30)}»`);
    if ((p.text||'') !== (d.text||'')) subs.push(`текст изменён`);
    if ((p.link||'') !== (d.link||'')) subs.push(`ссылка: «${p.link||'нет'}» → «${d.link||'нет'}»`);
    if (subs.length > 0) details.push({ sub: `«${truncate(label,40)}»: ${subs.join(', ')}`, sign: '~' });
  }
  return details;
}

function computeDiff(draft, prod) {
  const changes = [];

  // Текстовые поля
  for (const [key, label] of Object.entries(TEXT_LABELS)) {
    const a = prod[key] || '';
    const b = draft[key] || '';
    if (a !== b) {
      changes.push({ type: 'text', label, from: truncate(a), to: truncate(b) });
    }
  }

  // Фото/обложки
  for (const key of IMG_KEYS) {
    const a = prod[key] || '';
    const b = draft[key] || '';
    if (a !== b) {
      changes.push({ type: 'image', label: IMG_LABELS[key] || key, from: a, to: b });
    }
  }

  // Преимущества
  const pAdv = prod.advantages || [];
  const dAdv = draft.advantages || [];
  if (JSON.stringify(pAdv) !== JSON.stringify(dAdv)) {
    const details = diffAdvantages(pAdv, dAdv);
    changes.push({ type: 'section', label: 'Блок «Почему мы» (преимущества)', details });
  }

  // Фичи страниц + позиции блоков
  const featLabels = { adventuresFeatures:'путешествия', studyFeatures:'обучение', racesFeatures:'регаты', mainFeatures:'главная' };
  for (const [k, name] of Object.entries(featLabels)) {
    const pF = prod[k] || [];
    const dF = draft[k] || [];
    if (JSON.stringify(pF) !== JSON.stringify(dF)) {
      const details = diffAdvantages(pF, dF);
      changes.push({ type: 'section', label: `Блок фич: ${name}`, details });
    }
  }
  const belowLabels = { adventuresFeaturesBelow: 'Позиция блока фич (путешествия)', studyFeaturesBelow: 'Позиция блока фич (обучение)', racesFeaturesBelow: 'Позиция блока фич (регаты)' };
  for (const [k, label] of Object.entries(belowLabels)) {
    if (!!prod[k] !== !!draft[k]) {
      changes.push({ type: 'text', label, from: prod[k] ? 'после карточек' : 'до карточек', to: draft[k] ? 'после карточек' : 'до карточек' });
    }
  }

  // Флаги «на всю ширину»
  const wideLabels = {
    adventuresFeaturesTextWide: 'Полная ширина текста фич (путешествия)',
    studyFeaturesTextWide:      'Полная ширина текста фич (обучение)',
    racesFeaturesTextWide:      'Полная ширина текста фич (регаты)',
    adventuresCtaTextWide:      'Полная ширина CTA (путешествия)',
    studyCtaTextWide:           'Полная ширина CTA (обучение)',
    racesCtaTextWide:           'Полная ширина CTA (регаты)',
    pricingIntroWide:           'Полная ширина вводного текста (цены)',
    pricingIncludedWide:        'Полная ширина блока «включено» (цены)',
    pricingExcludedWide:        'Полная ширина блока «не включено» (цены)',
    pricingFooterWide:          'Полная ширина финального текста (цены)',
    iymcsText1Wide:             'Полная ширина описания IYMCS (1)',
    iymcsText2Wide:             'Полная ширина описания IYMCS (2)',
    pricingCtaTextWide:         'Полная ширина блока «Задать вопрос» (цены)',
  };
  for (const [k, label] of Object.entries(wideLabels)) {
    if (!!prod[k] !== !!draft[k]) {
      changes.push({ type: 'text', label, from: prod[k] ? 'полная ширина' : 'стандартная', to: draft[k] ? 'полная ширина' : 'стандартная' });
    }
  }

  // FAQ
  if (JSON.stringify(prod.faqItems || []) !== JSON.stringify(draft.faqItems || [])) {
    const pFaq = prod.faqItems || [];
    const dFaq = draft.faqItems || [];
    const details = [];
    const maxLen = Math.max(pFaq.length, dFaq.length);
    for (let i = 0; i < maxLen; i++) {
      const p = pFaq[i], d = dFaq[i];
      const label = truncate(d?.question || p?.question || `FAQ #${i+1}`, 50);
      if (!p && d) { details.push({ sub: `добавлен: «${label}»`, sign: '+' }); continue; }
      if (p && !d) { details.push({ sub: `удалён: «${label}»`, sign: '-' }); continue; }
      const subs = [];
      if ((p.question||'') !== (d.question||'')) subs.push('вопрос изменён');
      if ((p.answer||'') !== (d.answer||'')) subs.push('ответ изменён');
      if ((p.category||'') !== (d.category||'')) subs.push(`категория: ${p.category||'—'} → ${d.category||'—'}`);
      if (!!p.wide !== !!d.wide) subs.push(d.wide ? 'ширина: полная' : 'ширина: стандартная');
      if (subs.length > 0) details.push({ sub: `«${label}»: ${subs.join(', ')}`, sign: '~' });
    }
    changes.push({ type: 'section', label: 'FAQ', details });
  }

  // Инструкторы
  if (JSON.stringify(prod.instructors || []) !== JSON.stringify(draft.instructors || [])) {
    const details = diffInstructors(prod.instructors||[], draft.instructors||[]);
    changes.push({ type: 'section', label: 'Инструкторы / Команда', details });
  }

  // Яхты
  if (JSON.stringify(prod.yachts || []) !== JSON.stringify(draft.yachts || [])) {
    const details = diffArrayItems(prod.yachts||[], draft.yachts||[], x => x.name||x.title||'Яхта');
    changes.push({ type: 'section', label: 'Яхты / Флот', details });
  }

  // Упаковочный список
  if (JSON.stringify(prod.packingItems || []) !== JSON.stringify(draft.packingItems || [])) {
    const details = diffArrayItems(prod.packingItems||[], draft.packingItems||[], x => x.title||x.name||'Раздел');
    changes.push({ type: 'section', label: 'Список вещей', details });
  }

  // Иконки уровней сложности
  const diffIconsLabels = {
    adventuresDifficultyIcons: 'Иконки сложности — Путешествия',
    studyDifficultyIcons:      'Иконки сложности — Обучение',
    racesDifficultyIcons:      'Иконки сложности — Регаты',
  };
  for (const [k, label] of Object.entries(diffIconsLabels)) {
    const pIcons = prod[k] || [];
    const dIcons = draft[k] || [];
    if (JSON.stringify(pIcons) !== JSON.stringify(dIcons)) {
      const DEFAULT = ['lighthouse','lifebuoy','anchor','helm','yacht'];
      const from = (pIcons.length === 5 ? pIcons : DEFAULT).join(', ');
      const to   = (dIcons.length === 5 ? dIcons : DEFAULT).join(', ');
      changes.push({ type: 'text', label, from: truncate(from), to: truncate(to) });
    }
  }

  // Галерея главной
  const pGal = prod.mainGallery || [];
  const dGal = draft.mainGallery || [];
  if (JSON.stringify(pGal) !== JSON.stringify(dGal)) {
    const added = dGal.length - pGal.length;
    const detail = added > 0 ? `добавлено фото: +${added}` : added < 0 ? `удалено фото: ${added}` : `порядок или состав изменён (было ${pGal.length}, стало ${dGal.length})`;
    changes.push({ type: 'section', label: 'Галерея главной страницы', details: [{ sub: detail, sign: added >= 0 ? '+' : '-' }] });
  }

  // Подстраховка: любые поля контента, не описанные выше явно, но отличающиеся —
  // чтобы новые поля (добавленные в будущем) не пропадали из списка изменений молча.
  const HANDLED_KEYS = new Set([
    ...Object.keys(TEXT_LABELS), ...IMG_KEYS,
    'advantages', 'adventuresFeatures', 'studyFeatures', 'racesFeatures', 'mainFeatures',
    'adventuresFeaturesBelow', 'studyFeaturesBelow', 'racesFeaturesBelow',
    'adventuresFeaturesTextWide', 'studyFeaturesTextWide', 'racesFeaturesTextWide',
    'adventuresCtaTextWide', 'studyCtaTextWide', 'racesCtaTextWide',
    'pricingIntroWide', 'pricingIncludedWide', 'pricingExcludedWide', 'pricingFooterWide',
    'iymcsText1Wide', 'iymcsText2Wide', 'pricingCtaTextWide',
    'faqItems', 'instructors', 'yachts', 'packingItems',
    'adventuresDifficultyIcons', 'studyDifficultyIcons', 'racesDifficultyIcons',
    'mainGallery',
  ]);
  const allKeys = new Set([...Object.keys(prod || {}), ...Object.keys(draft || {})]);
  for (const key of allKeys) {
    if (HANDLED_KEYS.has(key)) continue;
    const a = prod[key];
    const b = draft[key];
    if (JSON.stringify(a) === JSON.stringify(b)) continue;
    if ((typeof b === 'object' && b !== null) || (typeof a === 'object' && a !== null)) {
      changes.push({ type: 'section', label: `Поле «${key}»`, details: [{ sub: 'изменено', sign: '~' }] });
    } else {
      changes.push({ type: 'text', label: `Поле «${key}»`, from: truncate(a), to: truncate(b) });
    }
  }

  return changes;
}

function computeCardsDiff(draftCards, prodCards) {
  const changes = [];
  for (const type of ['adventures','study','races','main','reviews']) {
    const dList = draftCards[type] || [];
    const pList = prodCards[type] || [];
    const pMap = Object.fromEntries(pList.map(c => [c.id, c]));
    const dMap = Object.fromEntries(dList.map(c => [c.id, c]));

    // Новые карточки
    for (const card of dList) {
      if (!pMap[card.id]) {
        changes.push({ type: 'card-new', label: TYPE_LABELS[type], title: card.title });
      }
    }
    // Удалённые
    for (const card of pList) {
      if (!dMap[card.id]) {
        changes.push({ type: 'card-del', label: TYPE_LABELS[type], title: card.title });
      }
    }
    // Изменённые
    for (const card of dList) {
      const old = pMap[card.id];
      if (!old) continue;
      const diffs = [];
      if (card.title !== old.title) diffs.push(`название: «${truncate(old.title,30)}» → «${truncate(card.title,30)}»`);
      if (card.price !== old.price) diffs.push(`цена: ${old.price||'—'} → ${card.price||'—'}`);
      if (card.isPublished !== old.isPublished) diffs.push(card.isPublished ? 'опубликована' : 'скрыта');
      if (card.image !== old.image) diffs.push('фото обложки');
      if (JSON.stringify(card.availableDates) !== JSON.stringify(old.availableDates)) {
        const oldSlots = (old.availableDates||[]).map(s => typeof s === 'object' ? s : { isoDate: s });
        const newSlots = (card.availableDates||[]).map(s => typeof s === 'object' ? s : { isoDate: s });
        const oldMap = Object.fromEntries(oldSlots.map(s => [s.isoDate, s]));
        const newMap = Object.fromEntries(newSlots.map(s => [s.isoDate, s]));
        const allDates = [...new Set([...Object.keys(oldMap), ...Object.keys(newMap)])].sort();
        const parts = [];
        for (const d of allDates) {
          const o = oldMap[d], n = newMap[d];
          if (!o) { parts.push(`+${fmtDate(d)}`); }
          else if (!n) { parts.push(`−${fmtDate(d)}`); }
          else if ((o.spaces ?? o.maxParticipants) !== (n.spaces ?? n.maxParticipants)) {
            parts.push(`${fmtDate(d)}: мест ${o.spaces ?? o.maxParticipants ?? '?'} → ${n.spaces ?? n.maxParticipants ?? '?'}`);
          }
        }
        diffs.push('даты' + (parts.length ? ': ' + parts.join(', ') : ''));
      }
      if (card.description !== old.description) diffs.push('описание');
      if ((card.location||'') !== (old.location||'')) diffs.push(`место: «${truncate(old.location||'—',25)}» → «${truncate(card.location||'—',25)}»`);
      if ((card.miles||'') !== (old.miles||'')) diffs.push(`мили: ${old.miles||'—'} → ${card.miles||'—'}`);
      if ((card.yachtId||card.yachtName||'') !== (old.yachtId||old.yachtName||'')) diffs.push(`яхта изменена`);
      if ((card.instructorId||'') !== (old.instructorId||'')) diffs.push(`инструктор изменён`);
      if ((card.instructorId2||'') !== (old.instructorId2||'')) diffs.push(`2й инструктор изменён`);
      if ((card.durationDays||'') !== (old.durationDays||'')) diffs.push(`длительность: ${old.durationDays||'—'} → ${card.durationDays||'—'} дн.`);
      if (JSON.stringify(card.badges||[]) !== JSON.stringify(old.badges||[])) {
        const oldB = (old.badges||[]).map(b => `${b.icon||''} ${b.text||''}`.trim());
        const newB = (card.badges||[]).map(b => `${b.icon||''} ${b.text||''}`.trim());
        const addedB = newB.filter(b => !oldB.includes(b));
        const removedB = oldB.filter(b => !newB.includes(b));
        const bParts = [...addedB.map(b => `+«${b}»`), ...removedB.map(b => `−«${b}»`)];
        diffs.push('значки' + (bParts.length ? ': ' + bParts.join(', ') : ''));
      }
      if (JSON.stringify(card.highlights||[]) !== JSON.stringify(old.highlights||[])) diffs.push('особенности');
      if (JSON.stringify(card.route||[]) !== JSON.stringify(old.route||[])) diffs.push('маршрут');
      if ((card.gallery||[]).join() !== (old.gallery||[]).join()) diffs.push(`галерея карточки`);
      if ((card.captain||'') !== (old.captain||'')) diffs.push(`капитан: «${old.captain||'—'}» → «${card.captain||'—'}»`);
      if ((card.difficulty||0) !== (old.difficulty||0)) diffs.push(`сложность: ${'★'.repeat(old.difficulty||0)||'—'} → ${'★'.repeat(card.difficulty||0)||'—'}`);
      if ((card.badge||'') !== (old.badge||'')) diffs.push(`лейбл на фото: «${old.badge||'—'}» → «${card.badge||'—'}»`);
      if ((card.scheduleText||'') !== (old.scheduleText||'')) diffs.push(`ссылка на расписание: «${truncate(old.scheduleText||'—',30)}» → «${truncate(card.scheduleText||'—',30)}»`);
      if ((card.level||'') !== (old.level||'')) diffs.push(`уровень: «${old.level||'—'}» → «${card.level||'—'}»`);
      if ((card.descriptionFull||'') !== (old.descriptionFull||'')) diffs.push('полное описание изменено');
      if (JSON.stringify(card.skills||[]) !== JSON.stringify(old.skills||[])) diffs.push('навыки («вы научитесь») изменены');
      if (!!card.locationClickable !== !!old.locationClickable) diffs.push(card.locationClickable ? 'локация стала кликабельной' : 'локация стала некликабельной');
      if ((card.captain2||'') !== (old.captain2||'')) diffs.push(`2й инструктор: «${old.captain2||'—'}» → «${card.captain2||'—'}»`);
      if ((card.routeDescription||'') !== (old.routeDescription||'')) diffs.push('описание маршрута изменено');
      if (!!card.anyDay !== !!old.anyDay) diffs.push(card.anyDay ? 'любой день: включено' : 'любой день: отключено');
      if ((card.startDayOfWeek != null ? String(card.startDayOfWeek) : '') !== (old.startDayOfWeek != null ? String(old.startDayOfWeek) : '')) diffs.push(`день начала изменён`);
      if (JSON.stringify(card.map||{}) !== JSON.stringify(old.map||{})) diffs.push('карта маршрута изменена');
      if ((card.slug||'') !== (old.slug||'')) diffs.push(`ссылка (slug): «${old.slug||'—'}» → «${card.slug||'—'}»`);

      // Подстраховка: поля карточки, не перечисленные явно выше, но отличающиеся
      const HANDLED_CARD_KEYS = new Set([
        'id','title','price','isPublished','image','availableDates','description','location',
        'miles','yachtId','yachtName','instructorId','instructorId2','durationDays','badges',
        'highlights','route','gallery','captain','difficulty','badge','scheduleText','level',
        'descriptionFull','skills','locationClickable','captain2','routeDescription','anyDay',
        'startDayOfWeek','map','slug',
      ]);
      const allCardKeys = new Set([...Object.keys(old||{}), ...Object.keys(card||{})]);
      for (const key of allCardKeys) {
        if (HANDLED_CARD_KEYS.has(key)) continue;
        if (JSON.stringify(old[key]) === JSON.stringify(card[key])) continue;
        diffs.push(`поле «${key}» изменено`);
      }

      if (diffs.length > 0) {
        changes.push({ type: 'card-mod', label: TYPE_LABELS[type], title: card.title, diffs });
      }
    }
  }
  return changes;
}

const ChangeSummaryModal = ({ onConfirm, onCancel, title, confirmLabel }) => {
  const { cards, productionCards } = useContext(CardsContext);
  const { content, productionContent } = useContext(SiteContentContext);

  const contentChanges = useMemo(() => computeDiff(content, productionContent), [content, productionContent]);
  const cardChanges = useMemo(() => computeCardsDiff(cards, productionCards), [cards, productionCards]);
  const totalChanges = contentChanges.length + cardChanges.length;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.55)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', padding: 20,
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, width: '100%', maxWidth: 640,
        maxHeight: '85vh', display: 'flex', flexDirection: 'column',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
      }}>
        {/* Шапка */}
        <div style={{ padding: '22px 28px 16px', borderBottom: '1px solid #f0f0f0' }}>
          <h2 style={{ margin: 0, fontSize: '1.2rem', color: '#1a2a3a' }}>
            📋 {title || 'Список изменений перед предпросмотром'}
          </h2>
          <p style={{ margin: '6px 0 0', fontSize: '0.88rem', color: '#888' }}>
            {totalChanges === 0
              ? 'Изменений нет — черновик совпадает с боевым сайтом'
              : `Найдено изменений: ${totalChanges}`}
          </p>
        </div>

        {/* Список */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '16px 28px' }}>

          {totalChanges === 0 && (
            <p style={{ color: '#aaa', textAlign: 'center', marginTop: 32 }}>✅ Всё совпадает с боевым сайтом</p>
          )}

          {/* Карточки */}
          {cardChanges.length > 0 && (
            <>
              <h3 style={{ fontSize: '0.85rem', fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: 1, margin: '0 0 10px' }}>Карточки</h3>
              {cardChanges.map((c, i) => (
                <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start', padding: '10px 0', borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontSize: 16, flexShrink: 0 }}>
                    {c.type === 'card-new' ? '🆕' : c.type === 'card-del' ? '🗑️' : '✏️'}
                  </span>
                  <div>
                    <span style={{ fontSize: '0.82rem', color: '#db782e', fontWeight: 600 }}>{c.label}</span>
                    {' · '}
                    <span style={{ fontSize: '0.9rem', color: '#333', fontWeight: 500 }}>{c.title}</span>
                    {c.type === 'card-new' && <span style={{ fontSize: '0.82rem', color: '#2e9e6b', marginLeft: 8 }}>добавлена</span>}
                    {c.type === 'card-del' && <span style={{ fontSize: '0.82rem', color: '#dc3545', marginLeft: 8 }}>удалена</span>}
                    {c.diffs && (
                      <div style={{ fontSize: '0.82rem', color: '#666', marginTop: 3 }}>
                        {c.diffs.join(' · ')}
                      </div>
                    )}
                  </div>
                </div>
              ))}
              <div style={{ marginBottom: 20 }} />
            </>
          )}

          {/* Контент */}
          {contentChanges.length > 0 && (
            <>
              <h3 style={{ fontSize: '0.85rem', fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: 1, margin: '0 0 10px' }}>Контент сайта</h3>
              {contentChanges.map((c, i) => (
                <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start', padding: '10px 0', borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontSize: 16, flexShrink: 0 }}>
                    {c.type === 'image' ? '🖼' : c.type === 'section' ? '📦' : '📝'}
                  </span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '0.85rem', fontWeight: 600, color: '#333', marginBottom: 4 }}>{c.label}</div>
                    {c.type === 'text' && (
                      <div style={{ fontSize: '0.82rem', color: '#666' }}>
                        <span style={{ color: '#dc3545' }}>было:</span> {c.from || '—'}
                        <br />
                        <span style={{ color: '#2e9e6b' }}>стало:</span> {c.to || '—'}
                      </div>
                    )}
                    {c.type === 'image' && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 4 }}>
                        <ImageThumb src={c.from} label="было" />
                        <span style={{ color: '#aaa', fontSize: 18 }}>→</span>
                        <ImageThumb src={c.to} label="стало" />
                      </div>
                    )}
                    {c.type === 'section' && (
                      <div style={{ fontSize: '0.82rem', color: '#666', marginTop: 2 }}>
                        {c.details && c.details.length > 0 ? c.details.map((d, di) => (
                          <div key={di} style={{ color: d.sign === '+' ? '#2e9e6b' : d.sign === '-' ? '#dc3545' : '#888', lineHeight: 1.5 }}>
                            {d.sign === '+' ? '＋' : d.sign === '-' ? '－' : '∼'} {d.sub}
                          </div>
                        )) : <span style={{ color: '#aaa' }}>изменено</span>}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </>
          )}
        </div>

        {/* Кнопки */}
        <div style={{ padding: '16px 28px 22px', borderTop: '1px solid #f0f0f0', display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
          <button onClick={onCancel} style={{
            padding: '9px 22px', borderRadius: 8, border: '1px solid #ddd',
            background: '#f5f5f5', cursor: 'pointer', fontSize: '0.9rem', color: '#555',
          }}>
            Назад
          </button>
          <button onClick={onConfirm} style={{
            padding: '9px 22px', borderRadius: 8, border: 'none',
            background: '#2196F3', color: '#fff', cursor: 'pointer',
            fontSize: '0.9rem', fontWeight: 600,
          }}>
            {confirmLabel || '👁️ Всё верно — открыть предпросмотр'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangeSummaryModal;
